module.exports = __webpack_public_path__ + "286d536e363150caa5f9a697dd89dc9b.MP3";